import { Component, Input } from '@angular/core';
import { TestHooks } from './writ.hooks';

@Component({
	selector: 'app-teranet-writ',
	templateUrl: './writ.component.html',
	styleUrls: ['./writ.component.scss'],
	standalone: false,
})
export class WritComponent {
	testHooks = TestHooks;
	@Input() hideButton = false;
}
